import Vue from 'vue';
import VueRouter from 'vue-router';
import Top from './components/Top.vue';
import Login from './components/Login.vue';
import Detail from './components/Detail.vue';
import Upload from './components/Upload.vue';
import Mypage from './components/Mypage.vue';
import SignUp from './components/SignUp.vue';
Vue.use(VueRouter);
const routes = [{
  path: '/',
  component: Top
}, {
  path: '/login/',
  name: 'login',
  component: Login
}, {
  path: '/detail/:pk/',
  name: 'detail',
  component: Detail
}, {
  path: '/up/',
  name: 'up',
  component: Upload
}, {
  path: '/up/:pk(\\d+)',
  name: 'up',
  component: Upload
}, {
  path: '/mypage/',
  name: 'mypage',
  component: Mypage
},{
  path: '/sign_up/',
  name: 'sign_up',
  component: SignUp
},{ // 上記のパス以外はloginに飛ばす 404ページとかを表示
  path: '*',
  redirect: '/login',
  component: Login
}];
const router = new VueRouter({
  routes,
  mode: 'history'
});
export default router;
